<template>

<main class="container">
    <h1>Accessibilité</h1>

    <p>Dans le cadre de notre engagement en faveur de l’accessibilité numérique, une analyse de conformité de ce site 
        est actuellement en cours selon les critères du Référentiel Général d’Amélioration de l’Accessibilité (RGAA). Cette 
        démarche vise à identifier les éventuels obstacles à l’accessibilité et à mettre en œuvre les actions nécessaires pour 
        garantir un accès équitable à l’ensemble des utilisateurs, y compris les personnes en situation de handicap. Nous vous 
        remercions de votre compréhension pendant cette phase d’évaluation et restons à votre écoute pour toute remarque ou 
        suggestion.</p>

</main>

</template>